// Per-user Active Job context. Stored keyed by user id so it NEVER leaks across
// role/account switches on a shared device. Business data stays shared server-side;
// only this UI navigation context is isolated per authenticated user.
const KEY = "sg_active_job";

export function getActiveJob(userId) {
  if (!userId) return null;
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "null");
    if (raw && raw.userId === userId) return raw.jobId || null;
  } catch {}
  return null;
}

export function setActiveJob(userId, jobId) {
  if (!userId) return;
  localStorage.setItem(KEY, JSON.stringify({ userId, jobId }));
}

export function clearActiveJob() {
  localStorage.removeItem(KEY);
}
